import * as React from 'react'
import classNames from 'classnames'

import LogoDark from 'ui-component-library/icons/crossfit-logo-dark.svg'
import LogoLight from 'ui-component-library/icons/crossfit-logo-light.svg'

import { useMediaQuery } from '../../MediaQuery'
import Link from 'content-components/_Primatives/Link'

import style from './style.scss'

export const LIGHT_LOGO = 'light' // white logo to be used on dark background
export const DARK_LOGO = 'dark' // dark logo to be used on white background

type Props = {
  ariaLabelText?: string
  className?: string
  desktopLogoWidth: number
  hasCustomLogo?: boolean
  visibleLogo: typeof DARK_LOGO | typeof LIGHT_LOGO
}

Logo.defaultProps = {
  ariaLabelText: '',
  className: '',
}

const MOBILE_SCALAR = 0.45
const TABLET_SCALAR = 0.58

/**
 * Original Logo is 240px, Crossfit-Games Logo is 300px
 */
function Logo(props: Props) {
  const { ariaLabelText, className, desktopLogoWidth, visibleLogo } = props
  const { belowTablet, belowMobile } = useMediaQuery({
    mobile: true,
    tablet: true,
  })

  const getLogoSize = (width: number) => {
    if (belowMobile) {
      return width * MOBILE_SCALAR
    }
    if (belowTablet) {
      return width * TABLET_SCALAR
    }
    return width
  }

  const LogoSVG = visibleLogo === 'light' ? LogoLight : LogoDark

  return (
    <Link url='/' aria-label={ariaLabelText}>
      <LogoSVG
        role='img'
        aria-label='CrossFit'
        className={classNames(style.logo, className)}
        style={{ width: getLogoSize(desktopLogoWidth) }}
      />
    </Link>
  )
}

export default Logo
